import { type FC, useRef } from 'react'

import { ChatButton } from '@liveHelper/components/shared/ChatButton'
import { useVisitorCanUseCamera } from '@liveHelper/hooks/useVisitorCanUseCamera'
import { CamButton } from '@oneToOne/liveHelper/components/shared/CamButton'
import { EndCallButton } from '@oneToOne/liveHelper/components/shared/EndCallButton'
import { MicButton } from '@oneToOne/liveHelper/components/shared/MicButton'
import { SettingsButton } from '@oneToOne/liveHelper/components/shared/SettingsButton'
import { SwitchCameraButton } from '@oneToOne/liveHelper/components/shared/SwitchCameraButton'
import { TRANSITION_CLASSNAMES } from '@oneToOne/shared/components/chat/constants'

import { useCssTransition } from '@core/hooks/useCssTransition'
import { isMobileWeb } from '@core/userAgent'

import { ButtonRow } from './VideoButtonRow.styles'

interface OnCallVideoButtonRowProps {
  isVisible: boolean
  isOnCall: boolean
  showChatButton?: boolean
}

/**
 * Shared component for Video Call Action buttons
 */
export const VideoButtonRow: FC<OnCallVideoButtonRowProps> = ({
  isVisible,
  isOnCall,
  showChatButton = true,
}) => {
  const isMobileWebEnabled = isMobileWeb()
  const buttonRowRef = useRef<HTMLDivElement>(null)
  const isCameraButtonVisible = useVisitorCanUseCamera()

  const { isMounted, className: transitionClassName } = useCssTransition({
    in: isVisible,
    timeout: 400,
    unmountOnExit: true,
    classNames: TRANSITION_CLASSNAMES.VIDEO_CONTROLS_BUTTON_ROW,
  })

  if (!isMounted) {
    return null
  }

  return (
    <ButtonRow ref={buttonRowRef} className={transitionClassName}>
      {isCameraButtonVisible && <CamButton isMinimized={true} />}
      <MicButton isMinimized={true} />
      {isMobileWebEnabled ? (
        <SwitchCameraButton isMinimized={true} />
      ) : (
        <SettingsButton isMinimized={true} />
      )}
      {showChatButton && <ChatButton isMinimized={true} chatEnabled={true} />}
      {isOnCall && <EndCallButton isMinimized={true} />}
    </ButtonRow>
  )
}
